export default __webpack_public_path__ + "static/media/landing-page-head-5.eb015c74.jpeg";